module.exports = __webpack_public_path__ + "static/media/up-arrow.891901ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/up-arrow.svg
// module id = 452
// module chunks = 0